import { RootState } from "@/store";
import { useSelector } from "react-redux";

export const useFiscalRulesListState = () => {
  return useSelector((state: RootState) => state.icmsList?.list || []);
};

export const useIcmsListState = useFiscalRulesListState;
